import React from 'react';
import { Search, Star } from 'lucide-react';
import { Input } from './ui/input';
import { cn } from '../lib/utils';

export const ModuleLibrary = ({
  modules, selectedId, onSelect,
  search, onSearchChange,
  sidefilter, onSidefilterChange
}) => {
  const filters = [
    { key: 'all', label: 'Tous' },
    { key: 'favorites', label: 'Favoris' },
    { key: 'seen', label: 'Déjà vus' },
    { key: 'unseen', label: 'À travailler' },
  ];

  return (
    <div className="mc-card p-5 hide-in-oral" data-testid="module-library">
      <h3 className="text-lg font-bold mb-1">Bibliothèque modules</h3>
      <p className="text-sm text-muted-foreground mb-4">Recherche, filtres, favoris, vus.</p>

      <div className="relative mb-3">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Rechercher un module, un mot-clé..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 rounded-xl h-11 bg-[hsl(var(--panel))]"
          data-testid="module-library-search"
        />
      </div>

      <div className="flex flex-wrap gap-2 mb-3">
        {filters.map(f => (
          <button
            key={f.key}
            onClick={() => onSidefilterChange(f.key)}
            className={cn(
              'px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors duration-200',
              sidefilter === f.key
                ? 'text-white border-transparent'
                : 'bg-[hsl(var(--panel))] border-border hover:bg-muted'
            )}
            style={sidefilter === f.key ? { background: 'linear-gradient(135deg, hsl(var(--primary)), hsl(var(--primary-dark)))' } : {}}
            data-testid={`module-library-filter-${f.key}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="space-y-2 max-h-[70vh] overflow-y-auto pr-1">
        {modules.length === 0 && (
          <div className="mc-soft p-4 text-sm text-muted-foreground" data-testid="module-library-empty">
            Aucun module trouvé.
          </div>
        )}
        {modules.map(m => (
          <button
            key={m.id}
            onClick={() => onSelect(m)}
            data-testid={`module-library-item-${m.id}`}
            className={cn(
              'w-full text-left rounded-2xl p-3.5 border transition-colors duration-200',
              selectedId === m.id
                ? 'border-[hsl(var(--primary))]/40'
                : 'bg-card border-border hover:bg-muted'
            )}
            style={selectedId === m.id ? { background: 'linear-gradient(180deg, hsl(var(--primary-soft)), hsl(var(--card)))' } : {}}
          >
            <div className="font-bold text-sm flex items-center gap-2">
              {m.is_favorite && <Star className="w-3.5 h-3.5 fill-current text-[hsl(var(--primary))]" />}
              {m.title}
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              {m.formation} · {m.duration}{m.is_seen ? ' · Vu' : ''}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
